export const defaultHeaders = new Headers({
    'Content-Type': 'application/json',
});
